module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconfont-loading",
    style: ({
      width: _vm.size,
      height: _vm.size
    })
  }, [_c('i', {
    staticClass: "iconfont icon-loading",
    style: ({
      fontSize: _vm.size,
      color: _vm.color,
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fb9267c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/items/iconfontLoading.vue
// module id = 889
// module chunks = 1